module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/time-7dc108d5dd2c3c153a4d27d18cdaa0c1.svg";